import useSWR from "swr"
import { fetcher } from "../utils/fetchers"
import { useRef, useEffect } from "react"

export default function useStatistics(metric_counter, date_start, date_end, selected_campaigns, selected_goals, type, selected_ads, graph_type, user_id) {
    //console.log(metric_counter,selected_campaigns,selected_goals,type, date_start.toISOString().slice(0,10))
    let _selected_goals = [...selected_goals].filter(x => x != "all_goals");
    let _selected_campaigns = [...selected_campaigns].filter(x => x != "all_campaigns");
    let _selected_ads = [...selected_ads].filter(x => x != "all_ads");

    const WITHOUT_CAMPAIGN_USER_ID = "0aeb7a8a-7120-49ab-b62c-13158dc69304";
    const skipCampaigns = user_id === WITHOUT_CAMPAIGN_USER_ID;

    const changeCounterRef = useRef(0);
    const prevParamsRef = useRef("");

    const currentParams = JSON.stringify({
        campaigns: _selected_campaigns.sort(),
        goals: _selected_goals.sort(),
        ads: _selected_ads.sort(),
        counter: metric_counter,
        date_start: date_start?.toLocaleDateString('en-CA'),
        date_end: date_end?.toLocaleDateString('en-CA'),
        graph_type
    });

    useEffect(() => {
        if (prevParamsRef.current !== currentParams) {
            changeCounterRef.current += 1;
            prevParamsRef.current = currentParams;
        }
    }, [currentParams]);

    let api = `api/v1/ya-metrika/counters`
    let swrKey = api
    if (metric_counter && date_start) {
        api = `api/v1/ya-metrika/stat?counter_id=${metric_counter}`
        _selected_campaigns?.map(((campaing) => (!skipCampaigns && campaing !== '0') ? api = api.concat(`&campaign_ids=${campaing}`) : ""))
        _selected_goals?.map(((goal) => (goal !== '0') ? api = api.concat(`&goal_ids=${goal}`) : ""))
        _selected_ads?.map(((ad) => (ad !== '0') ? api = api.concat(`&advert_ids=${ad}`) : ""))
        if (graph_type) {
            api = api.concat(`&graph_type=${graph_type}`);
        }
        api = api.concat(`&date_from=${date_start?.toLocaleDateString('en-CA')}&date_to=${date_end?.toLocaleDateString('en-CA')}&group=${type}`)
        swrKey = [api, changeCounterRef.current]
    }
    const { data, error, mutate } = useSWR(swrKey, (key) => {
        const url = Array.isArray(key) ? key[0] : key;
        return fetcher(url);
    }, { revalidateOnMount: true })

    const isLoading = !error && !data
    const loggedOut = Boolean(!isLoading && error)

    return {
        data,
        isLoading,
        loggedOut,
        mutate,
        error
    }
}
